<template>
  <section class="register">
    <div class="box" style="max-width: 70%; padding-bottom: 25px">
      <div class="header">
        <div class="title">{{ title }}</div>
        <div @click="close" class="close"><i class="fas fa-times"></i></div>
      </div>
      <div class="detail-item">
        <span>Acessaram</span>
        <div class="detail-bar">
          <div class="bar" :style="`width: ${getPercent(data.accessTotal, data.accessTotal)}%`"></div>
          <div class="value">{{ data.accessTotal }} <span>({{ getPercent(data.accessTotal, data.accessTotal) }}%)</span></div>
        </div>
      </div>
      <div v-if="id === 0" class="detail-item">
        <span>Logaram</span>
        <div class="detail-bar">
          <div class="bar" :style="`width: ${getPercent(data.signin, data.accessTotal)}%`"></div>
          <div class="value">{{ data.signin }} <span>({{ getPercent(data.signin, data.accessTotal) }}%)</span></div>
        </div>
      </div>
      <div v-if="id === 0" class="detail-item">
        <span>Cadastraram</span>
        <div class="detail-bar bar-3">
          <div class="bar" :style="`width: ${getPercent(data.signon, data.accessTotal)}%`"></div>
          <div class="value">{{ data.signon }} <span>({{ getPercent(data.signon, data.accessTotal) }}%)</span></div>
        </div>
      </div>
      <!-- <div v-if="id === 0" class="detail-item">
        <span>Pesquisaram</span>
        <div class="detail-bar">
          <div class="bar" :style="`width: ${getPercent(data.search, data.accessTotal)}%`"></div>
          <div class="value">{{ data.search }} <span>({{ getPercent(data.search, data.accessTotal) }}%)</span></div>
        </div>
      </div>
      <div v-if="id === 0" class="detail-item">
        <span>Acessaram um evento</span>
        <div class="detail-bar">
          <div class="bar" :style="`width: ${getPercent(data.show, data.accessTotal)}%`"></div>
          <div class="value">{{ data.show }} <span>({{ getPercent(data.show, data.accessTotal) }}%)</span></div>
        </div>
      </div>
      <div class="detail-item">
        <span>Selecionaram uma data</span>
        <div class="detail-bar">
          <div class="bar" :style="`width: ${getPercent(data.showDate, data.accessTotal)}%`"></div>
          <div class="value">{{ data.showDate }} <span>({{ getPercent(data.showDate, data.accessTotal) }}%)</span></div>
        </div>
      </div>
      <div class="detail-item">
        <span>Confirmaram os assentos</span>
        <div class="detail-bar">
          <div class="bar" :style="`width: ${getPercent(data.seat, data.accessTotal)}%`"></div>
          <div class="value">{{ data.seat }} <span>({{ getPercent(data.seat, data.accessTotal) }}%)</span></div>
        </div>
      </div>
      <div class="detail-item">
        <span>Informaram o tipo de ingresso</span>
        <div class="detail-bar">
          <div class="bar" :style="`width: ${getPercent(data.ticketType, data.accessTotal)}%`"></div>
          <div class="value">{{ data.ticketType }} <span>({{ getPercent(data.ticketType, data.accessTotal) }}%)</span></div>
        </div>
      </div>
      <div class="detail-item">
        <span>Escolheram a forma de pagamento</span>
        <div class="detail-bar">
          <div class="bar" :style="`width: ${getPercent(data.paymentMethod, data.accessTotal)}%`"></div>
          <div class="value">{{ data.paymentMethod }} <span>({{ getPercent(data.paymentMethod, data.accessTotal) }}%)</span></div>
        </div>
      </div>
      <div class="detail-item">
        <span>Pagamento realizado</span>
        <div class="detail-bar bar-2">
          <div class="bar" :style="`width: ${getPercent(data.bought, data.accessTotal)}%`"></div>
          <div class="value">{{ data.bought }} <span>({{ getPercent(data.bought, data.accessTotal) }}%)</span></div>
        </div>
      </div>
      <div class="detail-item">
        <span>Pagamento Recusado</span>
        <div class="detail-bar bar-4">
          <div class="bar" :style="`width: ${getPercent(data.payError, data.accessTotal)}%`"></div>
          <div class="value">{{ data.payError }} <span>({{ getPercent(data.payError, data.accessTotal) }}%)</span></div>
        </div>
      </div> -->
    </div>
  </section>
</template>

<script>
import logger from '../../logger'
import { getDetails } from '../api/analytics'

export default {
  props: ['id', 'iniDate', 'endDate', 'close', 'title'],
  data () {
    return {
      data: {}
    }
  },
  async mounted () {
    try {
      const data = await getDetails(this.iniDate, this.endDate, this.id)
      this.data = data
    } catch (error) {
      logger.error(error)
    }
  },
  methods: {
    getPercent (value, total) {
      if (!value || !total) return 0
      return Math.round(value / total * 100)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";

.detail-item {
  padding: 5px 20px;
  span {
    font-size: 0.85em;
    text-transform: uppercase;
    color: #333;
  }
}

.detail-bar {
  display: flex;
  align-items: center;
  margin-top: 2px;
  .bar {
    border-radius: 3px;
    border: 1px solid #0071b3;
    background-image: linear-gradient(to bottom right, #0071b3, #0098b3);
    height: 15px;
    min-width: 6px;
    transition: width 2s;
  }
  .value {
    flex-shrink: 0;
    font-size: 1em;
    font-weight: 500;
    color: #0071b3;
    padding: 0 10px;
    span {
      font-size: inherit;
      color: inherit;
      font-weight: 400;
    }
  }
  &.bar-2 {
    .bar {
      border: 1px solid #397b3c;
      background-image: linear-gradient(to bottom right, #4caf50, #397b3c);
    }
    .value {
      color: #397b3c;
    }
  }
  &.bar-3 {
    .bar {
      border: 1px solid $primary-color;
      background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
    }
    .value {
      color: $primary-color;
    }
  }
  &.bar-4 {
    .bar {
      border: 1px solid #9c1414;
      background-image: linear-gradient(to bottom right, #d31a1a, #9c1414);
    }
    .value {
      color: #9c1414;
    }
  }
}
</style>
